export default __webpack_public_path__ + "static/media/case_study_2.adc7df15.jpg";